<template>
  <div>
    <v-tabs>
      <v-tab href="#tab-1">{{ $t('quotation_item_tab_pay_item') }}</v-tab>
      <v-tab-item value="tab-1">
        <v-card flat>
          <v-card-text>
            <v-data-table
              :headers="payItemDataTableHeaders"
              :items="newPayItems"
              :search="searchPayItem"
              class="elevation-1"
              :no-data-text="$t('common_no_data')"
              :no-results-text="$t('common_no_results')"
              item-key="Index"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title> </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchPayItem"
                    append-icon="mdi-magnify"
                    :label="$t('quotation_item_new_install_search')"
                    single-line
                    hide-details
                    clearable
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    class="mb-2 ml-8"
                    :disabled="isAllTextFieldDisabled"
                    @click="openPayItem"
                  >
                    {{ $t('quotation_item_new_install_new_item_btn') }}
                  </v-btn>
                  <v-dialog
                    v-model="isShowEditPayItemDialog"
                    v-if="isShowEditPayItemDialog"
                    persistent
                  >
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ $t('quotation_item_return_pay') }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="dialogPayItem">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <pay-item-autocomplete
                                  :fatherEditedItem="editedPayItem"
                                  :editedItemIndex="editedPayItemIndex"
                                  :itemName="'quotation_item_number'"
                                  @setEditedPayItem="setEditedPayItem"
                                  v-if="editedPayItemIndex === -1"
                                  refName="payItemAutocomplete"
                                  @keyupEnter="focusNextInput"
                                />
                                <ValidationProvider
                                  :name="$t('quotation_item_number')"
                                  rules="required"
                                  v-slot="{ errors }"
                                  v-else
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Number"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_number') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_name')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Name"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_name') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="數量"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.BuyQuantity"
                                    :error-messages="errors[0]"
                                    @change="changePayTotal"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      數量
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_unit')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Unit"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_unit') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Price"
                                    :error-messages="errors[0]"
                                    @change="changePayTotal"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Discount"
                                    :error-messages="errors[0]"
                                    @change="changePayTotal"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣後單價"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.DiscountPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣後單價
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_total_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.TotalPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_total_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-textarea
                                  outlined
                                  :label="$t('quotation_item_remark')"
                                  v-model="editedPayItem.Remark"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeEditedPayItem">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="saveEditedPayItem">
                          {{ $t('common_save') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <delete-dialog
                    :isAllTextFieldDisable="false"
                    :isLoadingSaveBtn="false"
                    :isShowDeleteDialog="isShowDeletePayItemDialog"
                    :deleteMessage="'quotation_item_delete_item_dialog_title'"
                    @closeDelete="closeDeletePayItem"
                    @confirmDelete="confirmDeletePayItem"
                  />
                </v-toolbar>
              </template>
              <template v-slot:[`item.Edit`]="{ item }">
                <v-btn
                  icon
                  @click="isShowEditPayItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon small>
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click="isShowDeletePayItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon small>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.Move`]="{ item, index }">
                <v-btn
                  icon
                  @click="upPayItem(item)"
                  v-if="index !== 0"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon>
                    mdi-arrow-up-drop-circle-outline
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click="downPayItem(item)"
                  v-if="index !== newPayItems.length - 1"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon>
                    mdi-arrow-down-drop-circle-outline
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { extend } from 'vee-validate'
import { regex } from 'vee-validate/dist/rules'
import DeleteDialog from '@/components/DeleteDialog.vue'
import PayItemAutocomplete from '@/components/PayItemAutocomplete.vue'

extend('regex', regex)

export default {
  components: {
    DeleteDialog,
    PayItemAutocomplete
  },
  name: 'Repair',
  data: () => ({
    regexPrice: /^-[0-9]+$|^[0-9]+$/,
    regexQuantity: /^[0-9]+$/,
    searchPayItem: '',
    isShowEditPayItemDialog: false,
    editedPayItem: {
      Id: '',
      Number: '',
      Name: '',
      BuyQuantity: 0,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      TotalPrice: 0
    },
    defaultPayItem: {
      Id: '',
      Number: '',
      Name: '',
      BuyQuantity: 0,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      TotalPrice: 0
    },
    editedPayItemIndex: -1,
    isShowDeletePayItemDialog: false
  }),
  async mounted () {},
  computed: {
    payItemDataTableHeaders () {
      return [
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: '數量', align: 'end', value: 'BuyQuantity' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_item_price'), align: 'end', value: 'Price' },
        { text: '折扣', align: 'end', value: 'Discount' },
        { text: '折扣後單價', align: 'end', value: 'DiscountPrice' },
        { text: this.$t('quotation_item_total_price'), align: 'end', value: 'TotalPrice' },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false },
        { text: '調動', align: 'center', value: 'Move', sortable: false }
      ]
    },
    newPayItems () {
      let array = []
      this.payItemList.forEach((element, index) => {
        array.push(Object.assign(element, { Index: index }))
      })
      return array
    }
  },
  watch: {},
  methods: {
    setEditedPayItem (val) {
      this.editedPayItem.Id = val.Id
      this.editedPayItem.Number = val.Number
      this.editedPayItem.Name = val.Name
      this.editedPayItem.Unit = val.Unit
      this.editedPayItem.Price = val.Price
      this.editedPayItem.IsDelete = val.IsDelete
      this.editedPayItem.StoreNo = val.StoreNo
      this.changePayTotal()
      this.editedPayItem = JSON.parse(JSON.stringify(this.editedPayItem))
    },
    closeEditedPayItem () {
      this.isShowEditPayItemDialog = false
      this.editedPayItem = JSON.parse(JSON.stringify(this.defaultPayItem))
      this.editedPayItemIndex = -1
    },
    openPayItem () {
      this.isShowEditPayItemDialog = true
    },
    isShowEditPayItemDialogBtn (item) {
      this.editedPayItemIndex = this.newPayItems.indexOf(item)
      this.editedPayItem = JSON.parse(JSON.stringify(item))
      this.isShowEditPayItemDialog = true
    },
    async saveEditedPayItem () {
      const isValid = await this.$refs.dialogPayItem.validate()
      if (isValid) {
        this.$emit('setPayItemIndex', this.editedPayItemIndex)
        this.$emit('setPayItem', this.editedPayItem)
        this.closeEditedPayItem()
      }
    },
    isShowDeletePayItemDialogBtn (item) {
      this.editedPayItemIndex = this.newPayItems.indexOf(item)
      this.isShowDeletePayItemDialog = true
    },
    closeDeletePayItem () {
      this.editedPayItemIndex = -1
      this.isShowDeletePayItemDialog = false
    },
    confirmDeletePayItem () {
      this.$emit('deletePayItem', this.editedPayItemIndex)
      this.closeDeletePayItem()
    },
    changePayTotal () {
      if (
        this.regexPrice.test(this.editedPayItem.Price) &&
        this.regexQuantity.test(this.editedPayItem.BuyQuantity) &&
        this.regexQuantity.test(this.editedPayItem.Discount) &&
        this.regexQuantity.test(this.editedPayItem.DiscountPrice)
      ) {
        this.editedPayItem.DiscountPrice = this.editedPayItem.Price - this.editedPayItem.Discount
        this.editedPayItem.TotalPrice =
          this.editedPayItem.BuyQuantity * this.editedPayItem.DiscountPrice * 1
      }
    },
    downPayItem (item) {
      let temp = JSON.parse(JSON.stringify(this.newPayItems))
      let currentIndex = temp.findIndex((x) => x.Index === item.Index)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let nextObj = JSON.parse(JSON.stringify(temp[currentIndex + 1]))
      temp.splice(currentIndex + 1, 1, currentObj)
      temp.splice(currentIndex, 1, nextObj)
      this.$emit('setAllPay', temp)
    },
    upPayItem (item) {
      let temp = JSON.parse(JSON.stringify(this.newPayItems))
      let currentIndex = temp.findIndex((x) => x.Index === item.Index)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let preObj = JSON.parse(JSON.stringify(temp[currentIndex - 1]))
      temp.splice(currentIndex - 1, 1, currentObj)
      temp.splice(currentIndex, 1, preObj)
      this.$emit('setAllPay', temp)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    }
  },
  props: ['isAllTextFieldDisabled', 'customerId', 'payItemList']
}
</script>
